import { createRouter } from "./router";
import Cursus from "./components/Cursus.vue";
import { courseRouteUrl } from "./util/url";

export default {
    functional: true,
    props: {
        basePath: String,
        course: Object,
    },
    render(h, { props, data, children }) {
        const router = createRouter({
            mode: props.course ? 'abstract' : 'history',
            base: props.basePath
        });
        if(props.course) {
            router.replace(courseRouteUrl(router, props.course));
            return h({ ...Cursus, router }, {
                ...data,
                props: { course: props.course },
            }, children);
        }
        return h({ ...Cursus, router }, data, children);
    },
}
